import styled from 'styled-components';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .error {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  gap: 16px;

  & > :first-child {
    display: flex;
    justify-content: flex-end;
    width: 150px;
  }

  & > :last-child {
    max-width: 340px;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
`;
